export const CALLS_LIMIT_ON_ON_PAGE = 50;
